<template>
  <div v-if="store.getters.isVerified || !verifyRequired">
    <v-card
        class="ma-auto mt-5 rounded-xl mb-1"
        :max-width="props.maxWidth"
        color="dark-background"
        style="box-shadow: none"
    >
      <v-card class="fill-height" color="dark-background">
        <v-card-text>
          <v-btn
              v-if="back"
              color="white"
              variant="plain"
              @click="router.push(back);"
              class="pa-0 mb-2"
          >
            <v-icon icon="mdi-arrow-left" class="mr-2"></v-icon>{{$t('back')}}</v-btn>
          <slot name="content"></slot>
        </v-card-text>
      </v-card>
    </v-card>
  </div>
  <verify-required v-else/>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import VerifyRequired from '@/components/VerifyRequired';

const router = useRouter();
const store = useStore();

const props = defineProps({
  maxWidth: {
    type: [String, Number],
    default: 1200,
  },
  editingAs: {
    type: Boolean,
    default: false,
  },
  profileImageUrl: {
    type: String,
    default: null,
  },
  back: {
    type: String,
    default: null,
  },
  verifyRequired: {
    type: Boolean,
    default: true,
  },
});
</script>

<style scoped>
</style>
